import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import { useMemo, useRef } from 'react';

function App() {
  const {
    currentState,
    isVisible,
    currentMessage,
    messageAnimationTrigger,
    setDelay,
  } = useBroadcast();

  const { bg, phoneNumber, socials, title, qrCode, bgColor } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg, bgColor]);

  // контейнер с сообщением, нужен для скролинга текста сообщения в useScrollText
  const messagesRef = useRef(null);

  return (
    <div className="app-wrapper" style={{ background }}>
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
        nodeRef={messagesRef}>
        <div className="titre-wrapper" ref={messagesRef}>
          <div className="message-wrapper">
            <CSSTransition
              in={
                currentMessage &&
                (currentState === 'S3' || currentState === 'S1')
              }
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <SwitchTransition>
                <CSSTransition
                  key={messageAnimationTrigger}
                  addEndListener={(node, done) => {
                    node.addEventListener('transitionend', done, false);
                  }}
                  classNames="fade">
                  <Message
                    className="titre-message"
                    message={currentMessage?.message || {}}
                    setDelay={setDelay}
                    messagesWrapper={messagesRef.current}
                  />
                </CSSTransition>
              </SwitchTransition>
            </CSSTransition>
          </div>
          <CSSTransition
            in={currentState === 'S3' || currentState === 'S2'}
            timeout={500}
            classNames="fade-scale"
            unmountOnExit>
            <Advt className="titre-advt" advtInfo={advt_info} />
          </CSSTransition>
        </div>
      </CSSTransition>
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
